import { Body, Button, Icon } from '@assembly-js/design-system';
import { useTranslation } from 'react-i18next';

interface UnlockCardProps {
  onKeepGoing: () => void;
}

/** The "You're on a roll" card between checklist 1 and checklist 2. */
export const UnlockCard = ({ onKeepGoing }: UnlockCardProps) => {
  const { t } = useTranslation();

  return (
    <div className="mb-1 box-border flex w-full flex-col items-center gap-5 rounded-lg border border-solid border-gray-150 bg-white px-3 pb-3 pt-6">
      <div className="flex flex-col items-center gap-3">
        <span className="flex size-10 items-center justify-center rounded-[10px] bg-gray-150 text-black-heading">
          <Icon icon="Fire" aria-hidden="true" className="size-5" />
        </span>
        <Body tag="span" size="sm" className="leading-4.5! text-black-heading">
          {t(($) => $.page_apps.app_builder.getting_started.unlock.title)}
        </Body>
      </div>
      <Button
        label={t(
          ($) => $.page_apps.app_builder.getting_started.unlock.keep_going,
        )}
        variant="secondary"
        className="h-8 w-full"
        onClick={onKeepGoing}
      />
    </div>
  );
};
